import { Component, OnInit, HostListener, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../shared/services/apiService.service';
import { formatDate, isPlatformBrowser } from '@angular/common';
import { ClevertapService } from '../shared/services/clevertap/clevertap.service';
import { RootService } from '../shared/services/root.service';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { secureStorage } from '../shared/services/encryption/secureservice';
declare var $: any

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  sub: Subscription = new Subscription
  footerMenu: any;
  footerSCVList: any;
  footerBusesList: any;
  footerTruckList: any;
  isMobile:any = false;
  environment1 =environment.s3bucket.url;
  isShowChatbot:boolean=false
  isShowChatWin:boolean=false
  isUserLoggedIn: boolean;
  userData: any;
  isShow: boolean;
  urlSafe: SafeResourceUrl;
  urlSafe1: any = "";

  topPosToStartShowing = 100;
  mobile_no:any
  dealerCode: string;
  @HostListener('window:scroll')
  checkScroll() {
    if (isPlatformBrowser(this.platformId)) {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;


    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }
  }


  gotoTop() {
    if (isPlatformBrowser(this.platformId)) {

      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }


  constructor(private apiService: ApiService,private localStorage:secureStorage,
    private cleverService: ClevertapService,
    private behaviorService: BehaviourSubjectService,
    private storageService: RootService,
    private sanitizer: DomSanitizer,
    public router: Router,
    @Inject(PLATFORM_ID) private platformId: Object, private renderer: Renderer2,
  ) { }

  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {
    //   let element = document.getElementById('searchConsolebtn');
    // element.click();
      this.dealerCode= localStorage.getItem("dealercd");

      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      $('.chat-icon').on('click', function () {
        $('.chat-wrapper-close').removeClass('d-none');
        $('.chat-wrapper').addClass('d-none');
      });
      $('.chat-icon').on('click', function () {
        $('.chat-wrap').removeClass('d-none');
      });
      $('.close-chat').on('click', function () {
        $('.chat-wrap').addClass('d-none');
        $('.chat-wrapper-close').addClass('d-none');
        $('.chat-wrapper').removeClass('d-none');
      });
    }
    this.getFooterMenu()
    if (isPlatformBrowser(this.platformId)) {
    this.mobile_no= JSON.parse(this.localStorage.getItem("userData"))
    window['getMobileNo'] = this.getMobileNo.bind(this);
    }
    this.loadScript()
  }
  getUrl() {

      var result = '';
      let random;
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters?.length;
      for (var i = 0; i < 10; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      random = Date.now() + Math.floor(Math.random() * 100000000000000000000)
      random += Math.floor(Math.random() * 100000000000000000000)
      random += result
      let currentDateTime = formatDate(new Date(), "yyyyMMddHHmmss", "en-US");
      random += currentDateTime

      this.isShowChatWin = true;
      this.isShowChatbot = true;
      this.sub.add(this.behaviorService.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.storageService.isLoggedIn() ? true : false;
        this.userData = this.storageService.getUserData();
      }));
      if (this.isUserLoggedIn) {
        random = '';
        random = this.userData.mobile_number
      }
 //sandbox dev //5000        //3000
      // let string = `https://sdk.ucp-dev.tatamotors.com/?customerId=${random}&channel=OSP_WEB&platform=WEB&output=embed`;
// QA //8000
      // let string = `https://sdk.uep-staging.tatamotors.com/?customerId=${random}&channel=OSP_WEB&platform=WEB&output=embed`;
      //PROD //4000
      let string = `https://sdk.uep.tatamotors.com/?customerId=${random}&channel=OSP_WEB&platform=WEB&output=embed`;
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(string);
      this.urlSafe1 = string;

    
  }
  getFooterMenu() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('menuItem') && localStorage.getItem('menuItem').includes('data')) {
        let response = JSON.parse(localStorage.getItem('menuItem'));
        this.footerMenu = response.data;
        this.footerTruckList = {
          keys: Object.keys(this.footerMenu.trucks),
          values: Object.values(this.footerMenu.trucks),
          data: []
        }
        this.footerBusesList = {
          keys: Object.keys(this.footerMenu.buses),
          values: Object.values(this.footerMenu.buses),
          data: []
        }
        this.footerSCVList = {
          keys: Object.keys(this.footerMenu.SCVPickups),
          values: Object.values(this.footerMenu.SCVPickups),
          data: []
        }

        for (let i = 0; i < this.footerTruckList.keys?.length; i++) {
          let data = { name: this.footerTruckList.keys[i], link: this.footerTruckList.values[i]?.footerLink[0].name, display_name: this.footerTruckList.values[i]?.display_name[0].name }
          this.footerTruckList.data.push(data)
        }
        for (let i = 0; i < this.footerBusesList.keys?.length; i++) {
          let data = { name: this.footerBusesList.keys[i], link: this.footerBusesList.values[i]?.footerLink[0].name, display_name: this.footerBusesList.values[i]?.display_name[0].name }
          this.footerBusesList.data.push(data);
        }
        for (let i = 0; i < this.footerSCVList.keys?.length; i++) {
          let data = { name: this.footerSCVList.keys[i], link: this.footerSCVList.values[i]?.footerLink[0].name, display_name: this.footerSCVList.values[i]?.display_name[0].name }
          this.footerSCVList.data.push(data)
        }
      }
      else {
        this.sub.add(this.apiService.getMenuItemList()
          .subscribe({
            next: (response: any) => {
              if (isPlatformBrowser(this.platformId)) {
              localStorage.setItem('menuItem',JSON.stringify(response));
              }
              this.footerMenu = response.data;
              this.footerTruckList = {
                keys: Object.keys(this.footerMenu.trucks),
                values: Object.values(this.footerMenu.trucks),
                data: []
              }
              this.footerBusesList = {
                keys: Object.keys(this.footerMenu.buses),
                values: Object.values(this.footerMenu.buses),
                data: []
              }
              this.footerSCVList = {
                keys: Object.keys(this.footerMenu.SCVPickups),
                values: Object.values(this.footerMenu.SCVPickups),
                data: []
              }

              for (let i = 0; i < this.footerTruckList.keys?.length; i++) {
                let data = { name: this.footerTruckList.keys[i], link: this.footerTruckList.values[i]?.footerLink[0].name, display_name: this.footerTruckList.values[i]?.display_name[0].name }
                this.footerTruckList.data.push(data)
              }
              for (let i = 0; i < this.footerBusesList.keys?.length; i++) {
                let data = { name: this.footerBusesList.keys[i], link: this.footerBusesList.values[i]?.footerLink[0].name, display_name: this.footerBusesList.values[i]?.display_name[0].name }
                this.footerBusesList.data.push(data);
              }
              for (let i = 0; i < this.footerSCVList.keys?.length; i++) {
                let data = { name: this.footerSCVList.keys[i], link: this.footerSCVList.values[i]?.footerLink[0].name, display_name: this.footerSCVList.values[i]?.display_name[0].name }
                this.footerSCVList.data.push(data)
              }

            },
            error: () => { },
            complete: () => { }

          })
        )
      }
    }
  }
  SectionClick(sectioname: any) {

      try {
        this.cleverService.OnSectionClick(sectioname);
        this.behaviorService.isSmart.next(false);
      }
      catch { }
    
  }

  getCall(){
    this.behaviorService.isSmart.next(false);
  }

  hasInitMsgDisplayed: boolean = false;
  isChatbotLoaded: boolean = false;
  generateSessionId(mobile_no: any) {
    // Combine phone number with a random part and timestamp for uniqueness
    const randomPart = Math.random().toString(36).substr(2, 8); // Random string
    const timePart = Date.now().toString(36); // Timestamp in base36
    return `${mobile_no}-${timePart}-${randomPart}`;
  }

  // Example usage

  loadScript(): void {
    if (isPlatformBrowser(this.platformId)) {
    const currentPath = window.location.pathname;


    const userData = localStorage.getItem('userData');
    if (!userData) {
        console.warn("No user data found in localStorage. Closing chatbot.");
        if (window['toggleChatbox']) {
            window['toggleChatbox'](); // Close chatbot if already open
        }
        return; // Stop execution
    }

    // If chatbot is already loaded, allow toggling on any page
    if (this.isChatbotLoaded) {
      if (window['toggleChatbox']) {
        window['toggleChatbox']();
      } else {
        console.error('toggleChatbox function is not defined.');
      }
      return;

    }

    const phoneNumber = this.mobile_no?.mobile_number;
    const sessionId = this.generateSessionId(phoneNumber);
    localStorage.setItem('sessionId', sessionId);

    const script = this.renderer.createElement('script');
    script.src = 'assets/finalchatbot_osp/newChatbot.js';

    script.onload = () => {

      if (window['initializeChatbot']) {
        window['initializeChatbot'](sessionId);
        this.isChatbotLoaded = true;


        if (window['onloadfunction']) {
          window['onloadfunction']();
        } else {
          console.error('onloadfunction is not defined.');
        }

        if (currentPath === '/home') {
          setTimeout(() => {
            if (window['toggleChatbox']) {
              window['toggleChatbox']();
            } else {
              console.error('toggleChatbox function is not defined.');
            }
          }, 500);
        }

        // Ensure clicking the chatbot icon always works
        this.setupChatbotClickListener();
      } else {
        console.error('initializeChatbot function is not defined.');
      }
    };

    script.onerror = () => {
      console.error('Error loading chatbot script.');
    };

    this.renderer.appendChild(document.body, script);
  }
  }

  setupChatbotClickListener(): void {
    if (isPlatformBrowser(this.platformId)) {
    const chatIcon = document.getElementById("loadScriptID");
    if (chatIcon) {
      chatIcon.addEventListener("click", () => {
        if (window['toggleChatbox']) {
          window['toggleChatbox']();
        } else {
          console.error('toggleChatbox function is not defined.');
        }
      });
    } else {
      console.warn("Chatbot icon not found.");
    }
  }
  }


  // New function to toggle chatbox manually
  toggleChatboxVisibility(forceOpen: boolean = false): void {
    const chatbotElement = document.getElementById('chatbox');
    if (!chatbotElement) {
      console.error('Chatbox element not found.');
      return;
    }

    if (forceOpen || chatbotElement.style.display === 'none') {
      chatbotElement.style.display = 'block';
    } else {
      chatbotElement.style.display = 'none';
    }
  }

  // Ensure chatbot icon click works
  setupChatbotClickHandler(): void {
    const chatbotIcon = document.getElementById('chatbot-icon');
    if (!chatbotIcon) {
      console.error('Chatbot icon element not found.');
      return;
    }

    chatbotIcon.addEventListener('click', () => {
      this.toggleChatboxVisibility();
    });

  }


  attachCloseChatEvent(): void {
    // Wait for the close button to be available in the DOM
    setTimeout(() => {
      const closeChatIcon = document.getElementById("closeChatIcon");
      if (closeChatIcon) {
        closeChatIcon.addEventListener("click", () => {
          const chatbox = document.getElementById("chatContainer");
          if (chatbox) {
            chatbox.style.display = "none";
          }
        });
      } else {
        console.error("Close chat icon not found. Retrying...");
        this.attachCloseChatEvent(); // Retry attaching the event in case it's not yet loaded
      }
    }, 500);
  }
  getMobileNo(){
    if (isPlatformBrowser(this.platformId)) {
    let data=this.localStorage.getItem("userData")
    return data.mobile_no
    }
  }
}
